import { useParams } from "@tanstack/react-router";
import { useMemo } from "react";
import { createTradeMarketIdentity } from "../lib/hyperliquid";

export function useTradeSymbol() {
	const { symbol } = useParams({ from: "/_app/trade/$symbol" });

	return useMemo(() => createTradeMarketIdentity(symbol), [symbol]);
}
